import { Link, useSearchParams } from 'react-router-dom';
import { useDocumentTitle } from '../app/useDocumentTitle';
import { GuestOnly } from '../app/guards';
import { useT } from '../i18n/i18n';
import styles from './auth/AuthLayout.module.css';
import { EmailLinkForm } from './auth/EmailLinkForm';

export function RegisterPage() {
  const t = useT();
  useDocumentTitle(t('nav.register'));
  const [params] = useSearchParams();
  const next = params.get('next');
  return (
    <GuestOnly>
      <EmailLinkForm
        withName
        title={t('auth.registerTitle')}
        subtitle={t('auth.registerSubtitle')}
        submitLabel={t('auth.submitRegister')}
        footer={
          <p className={styles.switch}>
            {t('auth.haveAccount')}{' '}
            <Link to={`/login${next ? `?next=${encodeURIComponent(next)}` : ''}`}>
              {t('auth.toLogin')}
            </Link>
          </p>
        }
      />
    </GuestOnly>
  );
}
